import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormArray } from '@angular/forms';
import {
    AddressModel,
    assignModelOptions,
    ClientManagerInstanceToken,
    ClientManagerInterface,
    ConfigConstants,
    CseDopModel,
    NOTIFICATION_STATUS_CODE,
} from '@evorait/pace-core';
import { TranslateService } from '@ngx-translate/core';
import MaterialReturnP58Model from '../material-return-p58.model';

@Component({
    selector: 'pace-material-return-p58-detail',
    templateUrl: './material-return-p58-detail.component.html',
    styleUrls: ['./material-return-p58-detail.component.scss'],
})
export class MaterialReturnP58DetailComponent implements OnInit {
    @Output()
    public addressOptionChanged = new EventEmitter<void>();

    @Input()
    public model: MaterialReturnP58Model;

    @Output()
    public addressOptionChangedP58 = new EventEmitter<void>();

    @Input()
    public materialReturnChildren: FormArray;

    @Output()
    public formValidated = new EventEmitter<void>();

    public readonly displayRoom: boolean;
    public readonly displayBuilding: boolean;
    public readonly displayFloor: boolean;
    protected readonly NOTIFICATION_STATUS_CODE = NOTIFICATION_STATUS_CODE;
    public readonly deliveryReturnOptions = ConfigConstants.DeliveryReturnOptions;

    public constructor(
        private readonly changeDetector: ChangeDetectorRef,
        private readonly translate: TranslateService,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
    ) {
        this.displayRoom = this.clientManager.isNgmP58();
        this.displayBuilding = !this.clientManager.isNgmSA();
        this.displayFloor = !this.clientManager.isNgmSA();
    }

    public ngOnInit(): void {
        this.onAddressOptionChanged();
    }

    public validateForm(): void {
        if (this.model.enableStatesOfUSADropdown) {
            const isDopAddress =
                this.model.deliveryReturnOptions.selectedEntry.model.name === this.deliveryReturnOptions.Dop;
            const selectedCseDopModel = isDopAddress
                ? this.model.dropOffPointOptions.selectedEntry.model
                : this.model.customerAddressOptions.selectedEntry.model;
            AddressModel.updateStateOfUSA(selectedCseDopModel, '', isDopAddress);
        }
        this.changeDetector.detectChanges();
    }

    public onCityChange(cseDopModel: CseDopModel): void {
        if (!this.model.enableStatesOfUSADropdown) {
            return;
        }
        const isDopAddress =
            this.model.deliveryReturnOptions.selectedEntry.model.name === this.deliveryReturnOptions.Dop;
        AddressModel.updateStateOfUSA(cseDopModel, '', isDopAddress);
    }

    public onAddressOptionChanged(): void {
        const selectedDeliveryReturnOptions = this.model.deliveryReturnOptions.selectedEntry.model.name;

        if (!(selectedDeliveryReturnOptions === this.deliveryReturnOptions.Dop)) {
            this.model.dropOffPointOptions.deselect();
        }

        if (!(selectedDeliveryReturnOptions === this.deliveryReturnOptions.Customer)) {
            this.model.customerAddressOptions.deselect();
            this.model.returnInfo = assignModelOptions(
                this.model.returnInfo,
                {
                    ...this.model.returnInfo.options,
                    required: false,
                },
                this.model,
            );
            this.model.returnInfo = assignModelOptions(
                this.model.returnInfo,
                {
                    ...this.model.returnInfo.options,
                    placeholder: '',
                },
                this.model,
            );
        } else {
            this.model.returnInfo = assignModelOptions(
                this.model.returnInfo,
                {
                    ...this.model.returnInfo.options,
                    required: true,
                },
                this.model,
            );
            this.model.returnInfo = assignModelOptions(
                this.model.returnInfo,
                {
                    ...this.model.returnInfo.options,
                    placeholder: <string>this.translate.instant('MATERIAL_RETURN_RETURN_INFO_PLACEHOLDER'),
                },
                this.model,
            );
        }
        this.addressOptionChanged.emit();
    }
}
